import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from './../../UiComponents/Dialog';
import Company from './../../intro/pages/about/company';
import Character from './../../intro/pages/about/character';
import Objectives from './../../intro/pages/about/objectives';
import OrgChart from './../../mailThread/compose/actorsHandler/orgChart'
import ClientOrgChart from './../../mailThread/compose/actorsHandler/clientOrgChart'
import getLabel from './../../../utils/labels';
import OrgChartImage from './../../../globals/images/orgChart.png'
import styles from './helpContainer.module.scss';

class HelpContainer extends Component {
    constructor(props) {
        super(props);
    }

    checkIfOptionPresentInArray = (array, element) => {
        return array.includes(element);
    }

    getHelpPage = () => {
        let { screenId } = this.props;
        switch (screenId) {
            case 1: return <Company introductionData={this.props.introductionData} />
            case 2: return <Character orgChart={this.props.orgChart} actors={this.props.actors} introductionData={this.props.introductionData} />
            case 3: return <Objectives introductionData={this.props.introductionData} />
            case 4: return <div
                className={styles['orgchart-container']}
                style={{ background: 'white' }}
            >
                <OrgChart
                    selectedActors={[]}
                    orgChart={this.props.orgChart}
                    selfActor={this.props.selfActor}
                    checkIfOptionPresentInArray={this.checkIfOptionPresentInArray}
                />
                <ClientOrgChart
                    selectedActors={[]}
                    actors={this.props.actors}
                    checkIfOptionPresentInArray={this.checkIfOptionPresentInArray}
                    isIntroImage={true}
                />
            </div>
            default: return;
        }
    }

    getHelpTitle = () => {
        let { screenId, introductionData } = this.props;
        switch (screenId) {
            case 1: return introductionData.introPage.step1Header ? introductionData.introPage.step1Header : 'About Company'
            case 2: return introductionData.introPage.step2Header ? introductionData.introPage.step2Header : 'About Character'
            case 3: return introductionData.introPage.step3Header ? introductionData.introPage.step3Header : "Objectives"
            case 4: return getLabel('label_org_chart_text')
            default: return;
        }
    }

    render() {

        return (
            <Dialog
                title={this.getHelpTitle()}
                overlayClassName={styles.dialog}
                containerClassName={styles['overlay-container']}
                onClose={this.props.closeHelpScreen}
                isCloseButtonNeeded={true}
                isFooterNeeded={false}
                hideOverflow={true}
                contentStyle={{ alignItems: 'baseline' }}
            >
                {this.getHelpPage()}
            </Dialog>
        )
    }
}

HelpContainer.propTypes = {
    timeLeft: PropTypes.number
};

HelpContainer.defaultProps = {
    timeLeft: -1
};

export default HelpContainer;


// WEBPACK FOOTER //
// /src/components/header/helpContainer/HelpContainer.js